<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 半环形饼图-企业证书类型分析
	export default {
		name: 'EnterpriseDonutChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			chartData: {
				type: Array,
				required: true
			},
			title: {
				type: String,
				default: ''
			},

			// 中心显示的文本
			centerText: {
				type: [String, Number],
				default: ''
			},

			// 颜色列表
			colorList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {}
		},
		computed: {
			// 计算总数
			total() {
				return this.chartData.reduce((sum, item) => sum + item.value, 0)
			},
			chartOptions() {
				return {
					title: null,
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						right: 20,
						// left: 10,
						top: 'center',
						icon: 'circle',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							fontSize: 14
						}
					},
					color:
						this.colorList.length > 0
							? this.colorList
							: [
									'#1890ff', // 蓝色
									'#13c2c2', // 青色
									'#722ed1', // 紫色
									'#fa8c16', // 橙色
									'#8c8c8c' // 灰色
							  ],
					series: [
						{
							name: '证书类型',
							type: 'pie',
							radius: ['60%', '85%'], // 内外半径，形成环形
							center: ['37%', '50%'],
							startAngle: 360, // 起始角度设为360度，形成半环
							endAngle: 0, // 结束角度设为0度
							avoidLabelOverlap: true,
							label: {
								show: false
							},
							labelLine: {
								show: false
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							data: this.chartData
						},
						// 添加一个隐藏的半环，用于补全图形
						{
							name: '',
							type: 'pie',
							radius: ['60%', '85%'],
							center: ['37%', '50%'],
							startAngle: 0, // 从0度开始
							endAngle: -360, // 到-3600度结束
							silent: true, // 不响应鼠标事件
							label: {
								show: false
							},
							labelLine: {
								show: false
							},
							itemStyle: {
								color: 'rgba(0, 0, 0, 0.05)' // 灰色半透明
							},
							data: [{ value: 1, name: '' }]
						}
					],
					// 添加中心文本
					graphic: [
						{
							type: 'text',
							left: '34%',
							top: '47%',
							style: {
								text: this.centerText || this.total.toString(),
								fontSize: 30,
								fontWeight: 'bold',
								textAlign: 'center',
								fill: '#333'
							}
						}
					]
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
